import React from 'react';
import PropTypes from 'prop-types';
import RIEBase from 'components/core/editable/RIEBase';
import ReactDOM from 'react-dom';

/**
 * Modified from https://github.com/kaivi/riek, v1.1.0
 */
export default class RIENumber extends RIEBase {
    static propTypes = {
        format: PropTypes.func
    };

    /**
     * Default validate function for this component.  Can be overridden if validate property passed to component.
     * @param value
     * @returns {Object}
     */
    validate = (value) => {
        let validationResults = null;
        if (!isNaN(value) && isFinite(value)) {
            validationResults = {
                valid: true,
                canCommit: true,
                message: ''
            };
        } else {
            validationResults = {
                valid: false,
                canCommit: true,
                message: 'Entered value is not an integer.'
            };
        }
        return validationResults;
    };

    highlightComponentText = () => {
        const inputElem = ReactDOM.findDOMNode(this.refs.input);
        if (inputElem) {
            inputElem.focus();
            // element.setSelectionRange won't work for an input of type "number"
            setTimeout(() => { inputElem.select(); }, 10);
        }
    };

    renderReadComponent = () => {
        const value = this.getNewValue();
        // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
        // onFocus={this.startEditing}
        return (
            <span
                tabIndex="0"
                className={this.makeClassString()}
                onClick={this.startEditing}
                {...this.props.defaultProps}
            >
                {this.props.format ? this.props.format(value) : value}
            </span>
        );
    };

    renderEditingComponent = () => {
        return (
            <input
                disabled={(this.props.shouldBlockWhileLoading && this.state.loading)}
                type="number"
                className={this.makeClassString()}
                defaultValue={this.props.value}
                onChange={this.textChanged}
                ref="input"
                {...this.props.editProps}
            />
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIENumber.js